import { render, staticRenderFns } from "./CustomFieldMultiSelect.vue?vue&type=template&id=dbf78f72"
import script from "./CustomFieldMultiSelect.vue?vue&type=script&lang=ts"
export * from "./CustomFieldMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports